import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';

import { HttpClientModule } from '@angular/common/http';
import { CreditNoteDataService } from './services/credit-note-data.service';

import { LogoComponent } from './components/logo/logo.component';
import { CreditReasonComponent } from './components/credit-reason/credit-reason.component';
import { NoteComponent } from './components/note/note.component';
import { VatComponent } from './components/vat/vat.component';
import { MessageComponent } from './components/message/message.component';
import { ExchangerateComponent } from './components/exchangerate/exchangerate.component';
import { WriteOffDetailsComponent } from './components/write-off-details/write-off-details.component';
import { AdditionalInfoComponent } from './components/additional-info/additional-info.component';
import { HeaderComponent } from './components/header/header.component';

import { CustomCurrencyPipe } from './pipes/custom-currency.pipe';

@NgModule({
  // tslint:disable-next-line:max-line-length
  declarations: [LogoComponent, CreditReasonComponent, NoteComponent, VatComponent, MessageComponent, ExchangerateComponent, WriteOffDetailsComponent, AdditionalInfoComponent, HeaderComponent, CustomCurrencyPipe],
  imports: [
    CommonModule,
    HttpClientModule
  ],
  exports: [
    LogoComponent,
    CreditReasonComponent,
    VatComponent,
    NoteComponent,
    MessageComponent,
    HeaderComponent,
    WriteOffDetailsComponent,
    AdditionalInfoComponent,
    ExchangerateComponent,
    CommonModule,
    HttpClientModule,
    CustomCurrencyPipe
  ],
  providers: [
    CreditNoteDataService,
    CurrencyPipe
  ]
})
export class CoreModule { }
